import './App.scss';
import { BrowserRouter,Navigate,Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import { useContext } from 'react';
import { AuthContext } from './context/AuthContext';
import Index from './pages/Index';
import Add from './pages/Buy';
import Reports from './pages/Reports';
import Buy from './pages/Buy';
import Sell from './pages/Sell';
import History from './pages/History';


function App() {

  const {currentUser} = useContext(AuthContext)

  const RequireAuth = ({children}) => {
    return currentUser ? (children) : <Navigate to="/" />
  };

  return (
    <div className="App">
        <BrowserRouter>
        <Routes>
          <Route path="/">
            <Route exact path="/" element={<Login />} />
            <Route exact path="/index" element={<Index />} />
            <Route exact path="/buy" element={<Buy />} />
            <Route exact path="/sell" element={<Sell />} />
            <Route exact path="/history" element={<History />} />
            <Route exact path="/reports/:monthName" element={<Reports />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
